import { BaseNomenclatorModel } from './base.model';

export class TransportUnitDriverModel extends BaseNomenclatorModel {
    firstName: string;
    lastName: string;
    position: string;
    phone: string;
    email: string;
}
